var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('home-app-bar'),_c('home-nav-bar'),_c('home-view'),_c('home-footer'),_c('home-settings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }